// @ts-strict-ignore
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, output} from "@angular/core";
import {DisplayedMedia, Media, MediaType} from "@models";
import {EventEmitterService} from "@event-emitter";
import {SimMediasetService} from "@services";
import {isNaN} from "lodash-es";

@Component({
	selector: "sim-media-viewer",
	templateUrl: "./media-viewer.component.html",
	providers: [EventEmitterService],
	standalone: false,
})
export class MediaViewerComponent implements OnInit, OnChanges, OnDestroy {
	MediaType = MediaType;

	@Input() public displayedMedia: DisplayedMedia = null;
	@Input() public displayedMediaId: string = null;
	@Input() public autoSize = false;

	public mediaLoaded = output<void>();

	public media: Media = null;

	constructor(
		private _simMediasetService: SimMediasetService,
		private _emitterService: EventEmitterService,
	) {}

	public ngOnInit() {}

	public async ngOnChanges(changes: SimpleChanges) {
		if (
			changes["displayedMedia"] &&
			(changes["displayedMedia"].previousValue as DisplayedMedia)?.mediaId !== changes["displayedMedia"].currentValue?.mediaId
		) {
			this.media = await this._simMediasetService.getMediaById(this.displayedMedia.mediaId);
			this.mediaLoaded.emit();
			if (this.media?.mediaType == MediaType.PDF || this.media?.mediaType == MediaType.PowerPoint) {
				this.displayedMedia.currentPosition = Math.max(this.displayedMedia.currentPosition, 1);
			}
		}

		if (changes["displayedMediaId"]) {
			this.media = await this._simMediasetService.getMediaById(this.displayedMediaId);
			this.mediaLoaded.emit();
			this.displayedMedia = {
				mediaId: this.media.id,
				mediaType: this.media.mediaType,
				isPlaying: false,
				currentPosition: 0,
				isLooping: false,
				totalLength: 0,
				volume: this.displayedMedia?.volume !== null ? this.displayedMedia?.volume : 1,
			};

			if (this.media?.mediaType == MediaType.PDF || this.media?.mediaType == MediaType.PowerPoint) {
				this.displayedMedia.currentPosition = Math.max(this.displayedMedia.currentPosition, 1);
			}
		}
	}

	public ngOnDestroy(): void {}

	isValidVolume(volume: number): boolean {
		return volume !== null && !isNaN(volume);
	}
}
